import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';

import { HomeService } from '../../../modules/home/home.service';
import { SetupService } from '@core/services/setup';
import { LocalStorage } from '@core/localstorage';

@Component({
    selector: 'app-partners',
    templateUrl: './partners.component.html',
    styleUrls: ['./partners.component.scss'],
})
export class PartnersComponent implements OnInit {
    /**
     * RETORNO API
     * errors: Coleção de erros com falhas vindo do servidor
     * message: Mensagem de falha/sucesso processada pela API
     * statusCode: Código da mensagem de falha/sucesso processada pela API
     * registers: Retorno da coleção de dados solicitados a API
     */
    errors: any[] = [];
    message: string;
    statusCode: number;
    registers: any[];

    @ViewChild('carrouselLayout') carrousel: TemplateRef<any>;
    @ViewChild('straightPartners') straight: TemplateRef<any>;

    carrouselLayout: 0 | 1;

    constructor(
        private homeService: HomeService,
        private localStorage: LocalStorage,
        private setupService: SetupService
    ) {
        this.carrouselLayout = this.setupService.layout.components.partnerCarrouselToggle;
    }

    ngOnInit(): void {
        this.partners();
    }

    /**
     * parternsPerGroup() - Retorna a quantidade de certificações por grupo
     */
    get parternsPerGroup(): number {
        return window.innerWidth < 992 ? 2 : window.innerWidth >= 992 && window.innerWidth < 1240 ? 3 : 5;
    }

    /**
     * parternsGroups() - Retorna a quantidade de grupos de certificações
     */
    get parternsGroups(): number[] {
        return Array(Math.ceil(this.registers.length / this.parternsPerGroup))
            .fill(0)
            .map((_, i) => i);
    }

    get partnetLayout(): TemplateRef<any> {
        return this.carrouselLayout == 1 ? this.carrousel : this.straight;
    }

    get partnersByLevels(): any {
        const result = this.registers.reduce((acc, partner) => {
            if (acc[partner.partner_level] == null) {
                acc[partner.partner_level] = [partner];
            } else {
                acc[partner.partner_level].push(partner);
            }

            return acc;
        }, []);
        return result;
    }

    /**
     * lastVideos() - Buscar últimos vídeos publicados
     */
    partners() {
        //console.log('partners');
        this.homeService.getPartners().subscribe(
            (returnSuccess) => {
                this.successCallbackApi(returnSuccess);
            },
            (returnFail) => {
                this.errorCallbackServer(returnFail);
            }
        );
    }

    /**
     * successCallbackApi: Retorna resultado da API
     * @param response
     */
    successCallbackApi(response: any) {
        this.message = response.description;
        this.statusCode = response.status_code;
        this.registers = response.registers.data;
        //console.log(this.registers);
    }

    /**
     * errorCallbackServer: Retorna resultado de erros do servidor
     * @param fail
     */
    errorCallbackServer(fail: any) {
        this.errors = fail.error.errors;
        this.statusCode = 1; // erro
        this.registers = null;
    }

    get isCbt(): boolean {
        return (
            this.localStorage.getHost().includes('cbt.tenisintegrado.com.br') ||
            this.localStorage.getHost().includes('cbt.esp.br') ||
            this.localStorage.getHost().includes('cbt-tenis.com.br') ||
            this.localStorage.getHost().includes('cbtenis.com.br')
        );
    }
}
